var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"market"}},[(_vm.loading)?_c('loading-block'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }